export default __webpack_public_path__ + "static/media/about.75b8beee.jpg";